import { emDashUnicode } from '../../../utilities/constants';
import {
  filterVersionDate,
  filterVersionChangeField,
} from '../contract-header-history/contract-header-history-helpers';

export const processLineVersionData = (data) => {
  return data.map((version) => {
    const changedBy = version.createdByUser?.fullName ?? version.createdBy;
    const changedAt = version.createdAt;
    const changes = version.changes
      .filter((c) => c.changeType === 'v')
      .map((change) => ({
        ...change,
        category: change.category ?? emDashUnicode,
        equipmentCode: change.equipmentCode ?? emDashUnicode,
      }));
    const updates = version.changes
      .filter((c) => c.changeType === 'u')
      .map((change) => ({
        ...change,
        category: change.category ?? emDashUnicode,
        equipmentCode: change.equipmentCode ?? emDashUnicode,
        updatedBy: changedBy,
        updatedAt: changedAt,
      }));
    [...version.versionUpdates]
      .sort((a, b) => (a.createdAt < b.createdAt ? -1 : 1))
      .forEach((vu) => {
        updates.unshift(
          ...vu.changes.map((uc) => ({
            ...uc,
            category: uc.category ?? emDashUnicode,
            equipmentCode: uc.equipmentCode ?? emDashUnicode,
            updatedBy: vu.createdByUser?.fullName ?? vu.createdBy,
            updatedAt: vu.createdAt,
          })),
        );
      });

    return {
      contractVersion: version.contractHeaderVersion.versionNumber,
      contractLineVersion: version.versionNumber,
      modTag: version.modTag ?? emDashUnicode,
      changedBy,
      changedAt,
      changeCount: changes.length + updates.length,
      changes,
      updates,
    };
  });
};

export const filterAndSortVersions = (lineVersions, filters, order) => {
  const field = order[0];
  const asc = order[1] === 'ASC' ? -1 : 1;
  return lineVersions
    .filter(
      (v) =>
        (!filters.contractVersion ||
          v.contractVersion === +filters.contractVersion) &&
        (!filters.modTag || v.modTag === filters.modTag) &&
        (!filters.changedBy ||
          v.changedBy === filters.changedBy ||
          v.updates.some((c) => c.updatedBy === filters.changedBy)) &&
        filterVersionDate(filters.changedAtFrom, filters.changedAtTo, v) &&
        filterVersionChangeField(filters.tab, 'tab', v) &&
        filterVersionChangeField(filters.equipmentCode, 'equipmentCode', v) &&
        filterVersionChangeField(filters.fieldName, 'fieldName', v),
    )
    .sort((a, b) => (a[field] < b[field] ? asc : -asc));
};

export const getFilterOptions = (allVersions, field) => {
  const values = new Set();
  allVersions.forEach((v) => {
    if (field === 'contractVersion' || field === 'modTag') {
      values.add(v[field]);
    } else if (field === 'changedBy') {
      values.add(v.changedBy);
      v.updates.forEach((c) => values.add(c.updatedBy));
    } else if (
      field === 'tab' ||
      field === 'equipmentCode' ||
      field === 'fieldName'
    ) {
      v.changes.forEach((c) => values.add(c[field]));
      v.updates.forEach((c) => values.add(c[field]));
    }
  });
  return [
    { label: '-Select-', value: '' },
    ...[...values]
      .sort((a, b) => (a < b ? -1 : 1))
      .map((v) => ({ label: v, value: v })),
  ];
};
